import { FloatingTabs } from '@dbt-labs/sourdough';

import { PanelViewMode, panelViewModes } from './panelView';

const displayTextMap: Record<PanelViewMode, string> = {
  resources: 'Resources',
  fileTree: 'File tree',
  database: 'Database',
};

interface PanelViewSwitcherParams {
  navMode: PanelViewMode;
  updateNavMode: (mode: PanelViewMode) => void;
}

export const PanelViewSwitcher = ({
  navMode,
  updateNavMode,
}: PanelViewSwitcherParams) => {
  return (
    <div className="mb-2 flex items-center gap-2">
      <div className="-mx-9 w-full overflow-hidden whitespace-nowrap md:-mx-2">
        <FloatingTabs testId="panel-view-switcher">
          {panelViewModes.map((mode) => (
            <FloatingTabs.Tab
              key={mode}
              id={mode}
              isActive={mode === navMode}
              onClick={(): void => updateNavMode(mode)}
            >
              {displayTextMap[mode]}
            </FloatingTabs.Tab>
          ))}
        </FloatingTabs>
      </div>
    </div>
  );
};
